import React from "react";
import { TextField, MenuItem, Box, Typography } from "@mui/material";
import styles from "./Assessment.module.css";
import useAssessmentLabel from "../../hooks/useAssessmentLabel";

const OPTIONS = [
  { value: "Fit", label: "Fit" },
  { value: "Unfit", label: "Unfit" }
] as const;

const PresentHealthStatus = ({
  assessmentPresentHealthStatus,
  onChange
}: {
  assessmentPresentHealthStatus: string;
  onChange: (v: string) => void;
}): JSX.Element => {
  const assessmentLabels = useAssessmentLabel();
  const value = OPTIONS.some((opt) => opt.value === assessmentPresentHealthStatus)
    ? assessmentPresentHealthStatus
    : "";

  return (
    <Box className={styles.assessmentRow}>
      <Box className={styles.assessmentLabel}>
        <Typography component="span" fontWeight="600">
          {assessmentLabels.presentHealthStatus}
        </Typography>
      </Box>
      <Box className={styles.assessmentField}>
        <TextField
          size="small"
          variant="outlined"
          value={value}
          select
          fullWidth
          slotProps={{
            inputLabel: { shrink: true }
          }}
          onChange={(event) => {
            onChange(event.target.value);
          }}
        >
          {OPTIONS.map((item) => (
            <MenuItem key={item.value} value={item.value}>
              {item.label}
            </MenuItem>
          ))}
        </TextField>
      </Box>
    </Box>
  );
};

export default PresentHealthStatus;
